import { render, staticRenderFns } from "./Formacoes.vue?vue&type=template&id=7b01fa32&scoped=true"
import script from "./Formacoes.vue?vue&type=script&lang=js"
export * from "./Formacoes.vue?vue&type=script&lang=js"
import style0 from "./Formacoes.vue?vue&type=style&index=0&id=7b01fa32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b01fa32",
  null
  
)

export default component.exports